import React from "react";
import Input from "semantic-ui-react/dist/es/elements/Input";
import "./TextInput.scss";

const TextInput = React.forwardRef(({ className, ...props }, ref) => {
    return <Input ref={ref} {...props} className={`${className ? className : ""} customTextInput`} />;
});

export default TextInput;
